module.exports = __webpack_public_path__ + "img/policy-bg.3dbabc87.png";